import React from 'react'

const IconVideoTool = ({ style }) => {
   return (
      <svg viewBox='0 0 24 24' width='16' height='16' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' style={style}>
         <rect x='2' y='5' width='14' height='14' rx='1.5' />
         <path d='M16 10l6-3.5v11L16 14' strokeLinejoin='round' />
         <polygon points='7,9 12,12 7,15' fill='currentColor' stroke='none' />
      </svg>
   )
}
export default IconVideoTool
